import { Injectable } from "@angular/core";
import { Action } from "../../../section/master/model/action";
import { User, UserPost } from "../model/user";
import {
  UserDetail,
  PaymentModeOption,
  DashboardData
} from "../model/user-detail";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/map";
import { HttpClientService } from "../../../shared/service/http/http-client.service";
import { CookiesService } from "../../../shared/service/cookies/cookies.service";
@Injectable()
export class UserService {
  http: HttpClientService;
  cookie: CookiesService;
  objAction: Action;
  docData: any;
  data: User;
  dataPost: UserPost;
  profilePic: any[];
  document: any[];
  constructor(http: HttpClientService, cook: CookiesService) {
    this.http = http;
    this.cookie = cook;
    this.objAction = new Action(this.http, this.cookie);
  }
  saveUser(): Observable<User> {
    this.objAction.header = null;
    this.objAction.data = this.data;
    this.objAction.path = "api/Users/CreateUser";
    return this.objAction.save();
  }

  updateDocument(): Observable<any> {
    this.objAction.path = "api/Users/UpdateRegistration";
    this.objAction.data = this.docData;
    return this.objAction.update();
  }

  updateNotViewed(): Observable<any> {
    this.objAction.path = "api/Users/UpdateNotViewed";
    this.objAction.data = this.data;
    return this.objAction.update();
  }

  saveUserProfile(): Observable<UserDetail> {
    this.objAction.path = "api/Users/UpdateUserProfilePic";
    this.objAction.data = this.data;
    this.objAction.files = this.profilePic;
    return this.objAction.saveDataWithFiles();
  }
  savePostPic(): Observable<UserPost> {
    this.objAction.path = "api/Users/UpdatePostPic";
    this.objAction.data = this.dataPost;
    this.objAction.files = this.profilePic;
    return this.objAction.saveDataWithFiles();
  }
  saveDocuments(): Observable<any> {
    this.objAction.header = null;
    this.objAction.data = this.docData;
    this.objAction.files = this.document;
    this.objAction.path = "api/Users/UpdateMedicalCertificate";
    return this.objAction.saveDataWithFiles();
  }

  getUserDocument(id: number): Observable<any[]> {
    this.objAction.path = "api/Users/GetUsersDocument/" + id.toString();
    return this.objAction.get();
  }

  deleteUserDocument(id: number): Observable<string> {
    this.objAction.header = null;
    this.objAction.data = this.data;
    this.objAction.path = "api/Users/DeleteDocument?id=" + id;
    return this.objAction.delete();
  }

  getNotViewedUsers(): Observable<User[]> {
    this.objAction.path = "api/Users/GetNotViewedDoctor";
    return this.objAction.get();
  }
  getUsers(): Observable<User[]> {
    this.objAction.path = "api/Users/GetUsers";
    return this.objAction.get();
  }
  getForgetPassword(data: string): Observable<any> {
    this.objAction.header = null;
    this.objAction.path = "api/Users/GetForgetPassword?UserMailId=" + data;
    return this.objAction.get();
  }
  getUsersList(): Observable<UserDetail[]> {
    this.objAction.path = "api/Users/GetUsers";
    return this.objAction.get();
  }
  getUsersDetail(): Observable<UserDetail[]> {
    this.objAction.path = "api/Users/GetUsers";
    return this.objAction.get();
  }
  getUsersProfile(id: number): Observable<UserDetail[]> {
    this.objAction.path = "api/Users/GetUserProfileDetailByUser?UserId=" + id;
    return this.objAction.get();
  }

  getDoctorDetailsByRole(): Observable<UserDetail[]> {
    this.objAction.path = "api/Users/GetDoctorDetailsByRole";
    return this.objAction.get();
  }

  setPaymentModeOption(): Observable<string> {
    this.objAction.path = "api/Users/setPaymentMode";
    return this.objAction.get();
  }
  getDashboardData(): Observable<DashboardData> {
    this.objAction.path = "api/Users/GetDashboardDetails";
    return this.objAction.get();
  }
  getPaymentModeOption(): Observable<PaymentModeOption> {
    this.objAction.path = "api/Users/GetPaymentModeOption";
    return this.objAction.get();
  }
  getUserProfile(): Observable<UserDetail[]> {
    this.objAction.path = "api/Users/GetUserProfileDetail";
    return this.objAction.get();
  }
  updateUser(): Observable<User> {
    this.objAction.header = null;
    this.objAction.data = this.data;
    this.objAction.path = "api/Users/UpdateUser";
    return this.objAction.update();
  }

  updateUserStatus(): Observable<User> {
    this.objAction.header = null;
    this.objAction.data = this.data;
    this.objAction.path = "api/Users/UpdateUserStatus";
    return this.objAction.update();
  }

  updateUserCommStatus(): Observable<User> {
    this.objAction.header = null;
    this.objAction.data = this.data;
    this.objAction.path = "api/Users/UpdateUserCommStatus";
    return this.objAction.update();
  }

  UpdateReviewStatus(data: any): Observable<any> {
    this.objAction.header = null;
    this.objAction.data = data;
    this.objAction.path = "api/ClientReview/UpdateReviewStatus";
    return this.objAction.update();
  }

  deleteUser(usr: User): Observable<User> {
    this.objAction.header = null;
    this.objAction.data = this.data;
    this.objAction.path = "api/Users/DeleteUser?strUserId=" + usr.UserId;
    return this.objAction.delete();
  }

  getReviewByDoc(DocId: number): Observable<any[]> {
    this.objAction.path =
      "api/ClientReview/GetClientReviewByDoc?DocId=" + DocId;
    return this.objAction.get();
  }

  getFeedback(): Observable<any[]> {
    this.objAction.path = "api/ClientReview/GetFeedbacks";
    return this.objAction.get();
  }

  getReviews(): Observable<any[]> {
    this.objAction.path = "api/ClientReview/GetClientReview";
    return this.objAction.get();
  }

  DeleteClientReview(revid: number): Observable<User> {
    this.objAction.header = null;
    this.objAction.data = this.data;
    this.objAction.path =
      "api/ClientReview/DeleteClientReview?strClientReviewId=" + revid;
    return this.objAction.delete();
  }
  DeleteFeedback(id: number): Observable<any> {
    this.objAction.header = null;
    this.objAction.data = this.data;
    this.objAction.path =
      "api/ClientReview/DeleteClientFeedback?FeedbackId=" + id;
    return this.objAction.delete();
  }

  UpdateFeedbackStatus(data: any): Observable<any> {
    this.objAction.header = null;
    this.objAction.data = data;
    this.objAction.path = "api/ClientReview/UpdateFeedbackStatus";
    return this.objAction.update();
  }

  UpdateFeedback(data: any): Observable<any> {
    this.objAction.header = null;
    this.objAction.data = data;
    this.objAction.path = "api/ClientReview/UpdateFeedback";
    return this.objAction.update();
  }

  saveUserPost(): Observable<UserPost> {
    this.objAction.header = null;
    this.objAction.data = this.dataPost;
    this.objAction.path = "api/Users/CreateUserPost";
    return this.objAction.save();
  }
  updateUserPost(): Observable<UserPost> {
    this.objAction.header = null;
    this.objAction.data = this.dataPost;
    this.objAction.path = "api/Users/UpdateUserPost";
    return this.objAction.update();
  }
  getUserPost(): Observable<UserPost[]> {
    this.objAction.path = "api/Users/GetUserPost";
    return this.objAction.get();
  }
  getUserPostData(id: number): Observable<UserPost[]> {
    this.objAction.path = "api/Users/GetUserPost?id=" + id;
    return this.objAction.get();
  }
  deleteUserPost(objUserPost: UserPost): Observable<UserPost> {
    this.objAction.header = null;
    this.objAction.data = this.dataPost;
    this.objAction.path =
      "api/Users/DeleteUserPost?strPostId=" + objUserPost.PostId;
    return this.objAction.delete();
  }
}



// WEBPACK FOOTER //
// ./src/app/section/user/service/user.service.ts